import { useEffect, useState } from "react";

// Cards below 1200 CSS px, table from 1200 up. 1200 on purpose: the loaders' iPads
// (820 / 1180 CSS px, which they report as Macs) keep the cards in both orientations,
// while desktop windows keep the table. The layout follows the width, never the device type.
const NARROW_SCREEN_QUERY = "(max-width: 1199px)";

const matchesNow = (): boolean =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia(NARROW_SCREEN_QUERY).matches;

/** True while the window is narrower than 1200 CSS px; follows resizing and rotation. */
export function useNarrowScreen(): boolean {
  const [narrow, setNarrow] = useState(matchesNow);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const query = window.matchMedia(NARROW_SCREEN_QUERY);
    const onChange = () => setNarrow(query.matches);
    onChange();
    // Safari before 14 only has the old addListener pair.
    if (query.addEventListener) {
      query.addEventListener("change", onChange);
      return () => query.removeEventListener("change", onChange);
    }
    query.addListener(onChange);
    return () => query.removeListener(onChange);
  }, []);

  return narrow;
}
